// Phase 4 (G.5 sub-step 3) — standardized offense "Description" dropdown options
// from Lloyd's Client view doc.
export const OFFENSE_DESCRIPTION_OPTIONS = [
  'Speeding',
  'Control Device (stop sign / stop light)',
  'FTMFR (no insurance)',
  'No Registration',
  'Tinted Windows',
  'No License / Invalid License',
  'Accident',
  'Drug Paraphernalia',
  'Weight Violation',
  'Vehicle',
  'Other',
];
